import { GET_NUMBER_OF_SEATS } from "../components/action-types"


const getNumberOfSeatsReducer = (state = [], action) => {
    switch (action.type) {
        case (GET_NUMBER_OF_SEATS):
            return state = action.payload
        default:
            return state
    }
}

export default getNumberOfSeatsReducer;